<app-toast></app-toast>

<div>
    <router-outlet></router-outlet>
</div>